// src/pages/LoginPage/renderers/Toast.jsx
import React from 'react';

/**
 * Componente de notificação Toast (alerta temporário)
 *
 * @param {Object} props
 * @param {boolean} props.status - true para sucesso, false para alerta/erro
 * @param {string} props.message - Mensagem a ser exibida
 * @param {Function} [props.onClose] - Callback ao clicar no botão de fechar
 * @returns {JSX.Element}
 */
const Toast = ({ status, message, onClose }) => {
  const iconClasses = 'w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0';
  const iconSuccess = 'text-green-500 bg-green-100 dark:bg-green-800 dark:text-green-200';
  const iconWarning = 'text-yellow-500 bg-yellow-100 dark:bg-yellow-700 dark:text-yellow-200';

  return (
    <div
      id="toast-alert"
      role="alert"
      className="fixed flex justify-center items-center w-full bottom-5 z-50"
    >
      <div className="max-w-xs flex items-center p-2 text-gray-700 bg-white rounded-lg shadow dark:text-gray-200 dark:bg-gray-800">
        <div className={`${iconClasses} ${status ? iconSuccess : iconWarning}`}>
          {status ? (
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
            </svg>
          ) : (
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z" />
            </svg>
          )}
        </div>

        <div className="ms-3 text-sm font-normal">{message}</div>

        {typeof onClose === 'function' && (
          <button
            onClick={onClose}
            aria-label="Fechar alerta"
            className="ms-auto -mx-1.5 -my-1.5 p-1.5 rounded-lg text-gray-400 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-500 dark:hover:text-white dark:hover:bg-gray-700"
          >
            <svg className="w-3 h-3" fill="none" viewBox="0 0 14 14">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default Toast;
